import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  rowFormatter,
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  countryColumns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './AuditFormReportUtils';


const CountryAuditFormReportPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.countryAuditFormReports }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/reportsCountry")) {
    const temp = menuList.find(q => q.url == "/reportsCountry")
    isFullAccess = temp.isFullAccess;
  }


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          <ContentRoute
            path="/reportsCountry"
            render={props =>
              <ObjectsPage
                rowFormatter={rowFormatter}
                filterByShowButton={true}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/reportsCountry"
                api="api/AuditFormResult"
                getFunctionName="GetCountryReport"
                exportfuncName="GetExcelCountryReport"
                currentState={currentState}
                columns={countryColumns}
                prepareFilter={prepareFilter}
                filterFields={filterFields}
                filterInitialValues={filterInitialValues}
                enablePagination={false}
                haveExportButton={true}
              />
            }
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default CountryAuditFormReportPage



